import React from 'react';
import { Card, BlockStack, InlineStack, Text, Badge, Box } from '@shopify/polaris';

/**
 * T057: BlurredSuggestion component.
 * Blurred preview card for paywalled suggestions beyond free-tier limit.
 */

interface BlurredSuggestionProps {
  count: number;
}

export function BlurredSuggestion({ count }: BlurredSuggestionProps): React.ReactElement | null {
  if (count <= 0) return null;

  return (
    <Card>
      <div
        style={{
          filter: 'blur(4px)',
          pointerEvents: 'none',
          userSelect: 'none',
          position: 'relative',
        }}
      >
        <BlockStack gap="300">
          {Array.from({ length: Math.min(count, 3) }, (_, i) => (
            <BlockStack key={i} gap="200">
              <InlineStack gap="200">
                <Badge>●●●●●</Badge>
                <Text as="span" variant="bodySm">
                  ████████ ████████
                </Text>
              </InlineStack>
              <Text as="p" variant="bodySm">
                ████████ ██████ ████████ ████████ ██████ ████████ ████ ██████
              </Text>
              {i < Math.min(count, 3) - 1 && <div style={{ borderTop: '1px solid var(--p-color-border)' }} />}
            </BlockStack>
          ))}
        </BlockStack>
      </div>
      <Box paddingBlockStart="300">
        <Text as="p" variant="bodySm" alignment="center" tone="subdued">
          {count} more suggestion{count > 1 ? 's' : ''} available with a paid plan
        </Text>
      </Box>
    </Card>
  );
}
